import { DefaultReminderTime } from '@repo/utils/types';
import { initialDefaultReminderTime } from '@repo/redux/reducers/user/metadata';
import Occasion from '@repo/utils/helpers/Occasion';
import * as chrono from 'chrono-node';

export default (
  parsedResult: chrono.ParsedResult,
  defaultTime: DefaultReminderTime = initialDefaultReminderTime,
): { text: string; occasion: Occasion } => {
  const year = parsedResult.start.get('year');
  const month = parsedResult.start.get('month');
  const day = parsedResult.start.get('day');
  const hour = parsedResult.start.isCertain('hour')
    ? parsedResult.start.get('hour')
    : defaultTime.hour;
  const minute = parsedResult.start.isCertain('minute')
    ? parsedResult.start.get('minute')
    : defaultTime.minute;
  const date = new Date(year, month - 1, day, hour, minute);
  let occasion = new Occasion(date);

  if (!parsedResult.start.isCertain('year')) {
    if (occasion.isPast) {
      date.setFullYear(new Date().getFullYear() + 1);
    }

    occasion = new Occasion(date);
  }

  return {
    text: parsedResult.text,
    occasion,
  };
};
